import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import SearchBar from "../components/SearchBar";
import RideResults from "../components/RideResults";
import Suggestion from "../components/Suggestion";
import Filter from "../components/Filter";  // ✅ New Filter component
import { useAuth } from "../context/AuthContext";

export default function SearchPage() {
  const location = useLocation();
  const { user } = useAuth();

  const params = new URLSearchParams(location.search);


  const [filters, setFilters] = useState({
    from: params.get("from") || "",
    to: params.get("to") || "",
    date: params.get("date") || "",
    passengers: params.get("passengers") || "",
    radius: params.get("radius") || 10,  // ✅ Default to 100
  });

  return (
    <div>
      <SearchBar filters={filters} setFilters={setFilters} />
      <Filter filters={filters} setFilters={setFilters} />  {/* ✅ Attractive filter toggle */}
      <RideResults filters={filters} user={user} />
      <Suggestion filters={filters} user={user} />
    </div>
  );
}